import anime from 'animejs';

const animateAccordion = (elementId, height) => {
  const element = document.getElementById(elementId);
  const currentHeight = element.style.height;
  if (currentHeight === height) {
    element.style.height = '0px';
    element.parentElement.parentElement.dataset.open = 'false';
  } else {
    element.style.height = height;
    element.parentElement.parentElement.dataset.open = 'true';
  }
};

// https://stackoverflow.com/a/41491458
const scaleWebsite = () => {
  const siteWidth = 360;
  const scale = screen.width / siteWidth;

  document
    .querySelector('meta[name="viewport"]')
    .setAttribute('content', `width=${siteWidth}, initial-scale=${scale}`);
};

scaleWebsite();

const init = () => {
  // Always scroll to top
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  animateHeader();
  animateQuestion();
  animateQuizPage();
  quizInteractions();
  level3Accordions();
  level5Accordions();
};
const animateHeader = () => {
  const element = document.querySelector('.js-header');
  if (!element) {
    return;
  }

  // Create a timeline with default parameters
  var tl = anime.timeline({
    duration: 2000,
  });

  tl.add({
    targets: '.js-header-bg',
    scale: [1.2, 1],
    duration: 1500,
    easing: 'easeOutQuart',
  })
    .add(
      {
        targets: '.js-heading',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 1000,
      },
      100,
    )
    .add(
      {
        targets: '.js-subtitle',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 1000,
      },
      300,
    )
    .add(
      {
        targets: '.js-level-step',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 1000,
      },
      400,
    )
    .add(
      {
        targets: '.js-nav',
        translateY: ['-50', '0'],
        opacity: [0, 1],
        duration: 500,
        easing: 'easeInOutQuart',
      },
      500,
    );
};

const animateQuestion = () => {
  const element = document.querySelector('.js-question');

  if (!element) {
    return;
  }

  // Animate question
  // Create a timeline with default parameters
  var tl = anime.timeline({
    duration: 2000,
  });

  const questionBoxHeight =
    document.querySelector('.js-question-box').clientHeight;

  tl.add({
    targets: '.js-question-background',
    scale: [1.2, 1],
    duration: 1000,
    easing: 'easeOutQuart',
  })
    .add(
      {
        targets: '.js-question-box',
        scale: [0.8, 1],
        height: [0, questionBoxHeight],
        duration: 1000,
        easing: 'easeOutQuart',
      },
      0,
    )
    .add(
      {
        targets: '.js-question-title',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 750,
        easing: 'easeOutQuart',
      },
      500,
    )
    .add(
      {
        targets: '.js-answer',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 500,
        easing: 'easeOutQuart',
        delay: anime.stagger(150),
      },
      600,
    );
};

const animateQuizPage = () => {
  const element = document.querySelector('.js-quiz');
  if (!element) {
    return;
  }

  // Create a timeline with default parameters
  var tl = anime.timeline({
    duration: 1000,
  });

  tl.add({
    targets: '.js-quiz-background',
    scale: [1.2, 1],
    duration: 1000,
    easing: 'easeOutQuart',
  })
    .add(
      {
        targets: '.js-heading',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 1000,
      },
      100,
    )
    .add(
      {
        targets: '.js-subtitle',
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 1000,
      },
      300,
    )
    .add(
      {
        targets: '.js-button-take-the-quiz',
        opacity: [0, 1],
        translateY: [20, 0],
        duration: 1000,
      },
      500,
    );
};

const quizInteractions = () => {
  const element = document.querySelector('.js-question');
  if (!element) {
    return;
  }

  const answers = document.querySelectorAll('.js-answer');
  answers.forEach((answer) => {
    answer.addEventListener('click', () => {
      if (document.body.classList.contains('has-answered')) {
        return;
      }
      document.body.className += ' has-answered';
      // @ts-ignore
      const nextPage = element.dataset.nextpage;
      const plate = answer.querySelector('.answer-plate');
      const index = answer.querySelector('.js-answer-index');
      const symbol = answer.querySelector('.answer-symbol');
      const figure = answer.querySelector('.answer-figure');
      if (true) {
        anime({
          targets: plate,
          width: '100%',
          easing: 'easeOutQuart',
          duration: 300,
        });
        anime({
          targets: answer,
          color: {
            value: '#fffff',
            duration: 0,
          },
          duration: 300,
          borderColor: 'rgba(91,175,221,0.3)',
        });
        anime({
          targets: index,
          opacity: 0,
          duration: 300,
        });
        anime({
          targets: symbol,
          opacity: '1',
          scale: [0.8, 1],
          duration: 750,
        });
        anime({
          targets: figure,
          opacity: {
            value: 1,
            delay: 150,
          },
          translateY: [0, '-100%'],
          duration: 1000,
          easing: 'easeOutElastic(1, 1)',
        });

        setTimeout(() => {
          window.location.replace(nextPage);
        }, 1000);
      }
    });
  });
};

const level3Accordions = () => {
  const accordions = document.querySelectorAll('.js-accordion');
  accordions.forEach((accordion) => {
    const el = accordion.querySelector('.js-accordion-button');
    const inner = accordion.querySelector('.js-accordion-inner') as HTMLElement;
    const parent = inner.parentElement;
    el.addEventListener('click', function () {
      const isOpen = parent.dataset.open === 'true' ? true : false;
      // Toogle the accordion
      if (isOpen) {
        let height = inner.clientHeight;
        inner.style.height = `${height}px`;
        anime({
          targets: inner,
          height: [height, 0],
          duration: 500,
          easing: 'easeOutQuart',
          begin: () => {
            parent.dataset.open = 'false';
          },
        });
      } else {
        inner.style.height = 'auto';
        let height = inner.clientHeight;
        inner.style.height = '0';
        anime({
          targets: inner,
          height: [0, height],
          duration: 500,
          easing: 'easeOutQuart',
          begin: () => {
            parent.dataset.open = 'true';
            inner.style.height = 'auto';
          },
        });
      }
    });
  });
};

const level5Accordions = () => {
  // add accordion 1, 2, 3
  if (document.getElementById('expand-1')) {
    document.getElementById('expand-1').addEventListener('click', function () {
      animateAccordion('expand-1-inner', '1000px');
    });
  }
  if (document.getElementById('expand-2')) {
    document.getElementById('expand-2').addEventListener('click', function () {
      animateAccordion('expand-2-inner', '280px');
    });
  }
  if (document.getElementById('expand-3')) {
    document.getElementById('expand-3').addEventListener('click', function () {
      animateAccordion('expand-3-inner', '160px');
    });
  }
};

document.addEventListener('DOMContentLoaded', function (event) {
  init();
});

// menu
const menuButton = document.getElementById('js-nav');
const overlay = document.getElementById('menu-overlay');

const openTl = anime.timeline({
  duration: 2000,
  autoplay: false,
});

openTl
  .add({
    targets: '#menu-overlay',
    opacity: [0, 1],
    duration: 500,
    begin: () => {
      overlay.classList.remove('hidden');
      overlay.classList.add('flex');
    },
  })
  .add(
    {
      targets: '#menu-inner',
      scale: [0.75, 1],
      opacity: [0, 1],
      // translateY: [100, 0],
      duration: 1200,
    },
    '-=400',
  )
  .add(
    {
      targets: '.menu-button',
      translateY: {
        value: ['-40px', '0'],
        easing: 'spring(1, 60, 10, 0)',
        duration: 1000,
      },
      scale: [0, 1],
      opacity: [0, 1],
      duration: 500,
      easing: 'easeInOutQuart',
      delay: anime.stagger(50),
    },
    '-=1300',
  );

const closeTl = anime.timeline({
  duration: 2000,
  autoplay: false,
});

closeTl.add({
  targets: '#menu-overlay',
  opacity: [1, 0],
  duration: 500,
  complete: () => {
    overlay.classList.add('hidden');
    overlay.classList.remove('flex');
  },
});

function toggleMenu() {
  if (overlay.classList.contains('hidden')) {
    openTl.restart();
  } else {
    openTl.pause();
    closeTl.play();
  }
}

menuButton.addEventListener('click', toggleMenu);
overlay.addEventListener('click', toggleMenu);
